import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["installButton", "iosInstructions"]

  connect() {
    // Only show install UI on mobile devices
    if (!this._isMobile()) return;

    // Already installed — nothing to show
    if (this._isStandalone()) return;

    if (this._isIOS()) {
      // iOS Safari doesn't fire beforeinstallprompt; show manual instructions
      if (this.hasIosInstructionsTarget) {
        this.iosInstructionsTarget.classList.remove("hidden");
      }
      return;
    }

    // Chrome / Edge / Samsung: wait for the browser install prompt
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      if (this.hasInstallButtonTarget) {
        this.installButtonTarget.classList.remove("hidden");
      }
    });

    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
      if (this.hasInstallButtonTarget) {
        this.installButtonTarget.classList.add("hidden");
      }
      if (this.hasIosInstructionsTarget) {
        this.iosInstructionsTarget.classList.add("hidden");
      }
    });
  }

  async install() {
    if (!this.deferredPrompt) return;
    this.deferredPrompt.prompt();
    const { outcome } = await this.deferredPrompt.userChoice;
    this.deferredPrompt = null;
    if (outcome === "accepted" && this.hasInstallButtonTarget) {
      this.installButtonTarget.classList.add("hidden");
    }
  }

  _isMobile() {
    return /android|iphone|ipad|ipod/i.test(navigator.userAgent) ||
           "ontouchstart" in window;
  }

  _isIOS() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent) &&
           !("MSStream" in window);
  }

  _isStandalone() {
    return window.navigator.standalone === true ||
           window.matchMedia("(display-mode: standalone)").matches;
  }
}
